<template>
<div id="app" class="disclaimer page-template-default page wp-custom-logo wp-embed-responsive post-image-aligned-center sticky-menu-fade sticky-enabled both-sticky-menu no-sidebar nav-below-header separate-containers header-aligned-left dropdown-hover">
  <HeadNav selectedLanguage="en" page="disclaimer" :gotodownload="gotodownload"
      :apk="apk"/>

  <div id="page" class="site grid-container container hfeed">
    <div id="content" class="site-content">
      <div id="primary" class="content-area">
        <main id="maincontent" class="site-main">
          <article class="page type-page status-publish">
            <div class="inside-article">
              <header class="entry-header section-content" aria-label="Content">
                <h1 class="entry-title" itemprop="headline">
                  Disclaimer
                </h1>
              </header>

              <div class="section-content" itemprop="text">
                <p>
                  The content on <strong>GB DwnPlus</strong> is provided for <strong>informational and educational purposes only</strong>. We do not develop, modify, or distribute GBWhatsApp or any related third-party applications. Our goal is solely to share accurate, helpful, and up-to-date information about the app's features, versions, and usage guidance.
                </p>

                <p>
                  While we strive to ensure all content on our website is correct and reliable, <strong>GB DwnPlus</strong> makes no guarantees—express or implied—regarding the accuracy, validity, availability, or completeness of the information presented.
                </p>

                <p>
                  Please note that <strong>GBWhatsApp</strong> is an unofficial third-party application that is <strong>not affiliated with, endorsed by, or connected to WhatsApp Inc.</strong> in any way. Using such modified apps may violate WhatsApp's Terms of Service and could result in account restrictions or suspension.
                </p>

                <p>
                  By using our site, you acknowledge that all information and downloads you access are done at your own discretion and risk. <strong>GB DwnPlus</strong> shall not be held responsible for any loss, data issues, or account-related consequences arising from the use of third-party apps.
                </p>
              </div>

              <div style="height: 20px" aria-hidden="true" class="wp-block-spacer" />
            </div>
          </article>
        </main>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'Disclaimer',
  components: {
    HeadNav,
  },
  data() {
    return {
      pageName: 'disclaimer',
      showapk: false,
      apk: null,
      from: 'gb',
      filename: 'gb',
    };
  },
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    console.log(this.$global.GetQueryString('from'));
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
  },
  methods: {
    downloadfrom(reason) {
      this.download();
      this.$logEvent(`download_from_${reason}`, 'download');
    },
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
            this.lastupdate = res.data.promotion.updateTime;
            this.votes = res.data.promotion.totalCount;
            this.rating = res.data.promotion.score;
            console.log('apk getted');
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    gotodownload() {
      console.log(this.apk);
      if (this.apk) {
        this.$global.download(this.apk);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
h1 {
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 2rem;
  color: #333;
  position: relative;
  padding-left: 20px;
}

h1::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: linear-gradient(to bottom, #25D366, #128C7E);
  border-radius: 2px;
}

h2 {
  font-size: 2rem;
  font-weight: bold;
  margin-top: 2rem;
  margin-bottom: 1.5rem;
  color: #333;
  position: relative;
  padding-left: 20px;
}

h2::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: linear-gradient(to bottom, #25D366, #128C7E);
  border-radius: 2px;
}

h3 {
  font-size: 1.5rem;
  font-weight: bold;
  margin-top: 1.5rem;
  margin-bottom: 1rem;
  color: #333;
  position: relative;
  padding-left: 15px;
}

h3::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: linear-gradient(to bottom, #25D366, #128C7E);
  border-radius: 2px;
}

.section-content {
  margin-top: 0;
  margin-bottom: 15px;
}

.section-content p {
  font-size: 1.1rem;
  line-height: 1.8;
  margin-bottom: 1.5rem;
  color: #555;
}

#maincontent {
  margin-top: 22px !important;
}

@media (max-width: 768px) {
  h1 {
    font-size: 2rem;
  }
  
  h2 {
    font-size: 1.5rem;
  }
  
  h3 {
    font-size: 1.2rem;
  }
}
</style>

